module.exports = __webpack_public_path__ + "static/media/bt.abfd38c8.svg";